import { useAppStore } from '@/state-management/store';

/**
 * Zustand selector hook to get the prescription pad rules, which `PrescriptionPadWrapper` sets from the feature flags.
 * Components read the rules here rather than from the flags, so they decide from the same rules as the store actions.
 * @returns the rules the store's alerts and the review step apply to the pad
 */
export const usePrescriptionPadRulesSelector = () =>
  useAppStore((state) => state.prescriptionAssistant.prescriptionPadRules);
